export const SET_LOADING = 'LOADING_STARTED';
export const SET_TOKENS = 'SET_TOKENS';
export const UNSET_TOKEN = 'UNSET_TOKEN';
export const SET_TOKEN = 'SET_TOKEN';
